import React, { useContext, useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
import axiosInstance from "../axiosConfig";
import { AuthContext } from "../AuthContext";
import Logo from "../assets/Img/Logo-1.png";
import User from "../assets/Img/User.gif";
import DataTable from "react-data-table-component";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

function UserDashboard() {
  const { user, logout } = useContext(AuthContext);
  const [department, setDepartment] = useState("Not Assigned");
  const [temporaryDepartment, setTemporaryDepartment] =
    useState("Not Assigned");
  // Data states
  const [workerData, setWorkerData] = useState([]); // final data after item filtering
  const [uniqueItems, setUniqueItems] = useState([]);
  const [selectedItem, setSelectedItem] = useState("All");
  //css
  const [hover, setHover] = useState(false);
  // Pagination and totals
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5; // Number of items per page for mobile view
  const [totalAmount, setTotalAmount] = useState(0);

  // Date filters
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [totalQty, setTotalQty] = useState(0);

  const [lotWiseData, setLotWiseData] = useState([]);
  const [allLotWiseData, setAllLotWiseData] = useState([]);

  // useEffect(() => {
  //   const fetchTotalAmount = async () => {
  //     if (!user?.EmployeeID) return;

  //     try {
  //       const response = await axiosInstance.get(`/api/worker-total-amount/${user.EmployeeID}`);
  //       setTotalAmount(response.data.TotalAmount || 0); // Store total amount
  //     } catch (error) {
  //       console.error("Error fetching total amount:", error);
  //     }
  //   };

  //   fetchTotalAmount();
  // }, [user?.EmployeeID]);

  ////new code for worker data
  // useEffect(() => {
  //   const fetchWorkerData = async () => {
  //     try {
  //       const response = await axiosInstance.get("api/worker-wages");
  //       const filteredData = response.data.filter(
  //         (item) => item.EmployeeID === user?.EmployeeID
  //       );
  //       setWorkerData(filteredData);
  //     } catch (error) {
  //       console.error("Error fetching worker wages data:", error);
  //     }
  //   };

  //   fetchWorkerData();

  //   const handleResize = () => {
  //     setIsMobile(window.innerWidth <= 768);
  //   };

  //   window.addEventListener("resize", handleResize);
  //   return () => window.removeEventListener("resize", handleResize);
  // }, [user?.EmployeeID]);
  // useEffect(() => {
  //   const fetchWorkerData = async () => {
  //     try {
  //       const response = await axiosInstance.get("api/worker-wages");
  //       let filteredData = response.data.filter(
  //         (item) => item.EmployeeID === user?.EmployeeID
  //       );

  //       if (startDate && endDate) {
  //         const start = new Date(startDate);
  //         const end = new Date(endDate);
  //         filteredData = filteredData.filter(item => {
  //           const date = new Date(item.Payroll_Entry_Date);
  //           return date >= start && date <= end;
  //         });
  //       }

  //       setWorkerData(filteredData);
  //     } catch (error) {
  //       console.error("Error fetching worker wages data:", error);
  //     }
  //   };

  //   fetchWorkerData();

  //   const handleResize = () => {
  //     setIsMobile(window.innerWidth <= 768);
  //   };

  //   window.addEventListener("resize", handleResize);
  //   return () => window.removeEventListener("resize", handleResize);
  // }, [user?.EmployeeID, startDate, endDate]);

  const [advanceAmount, setAdvanceAmount] = useState(0);
  useEffect(() => {
    const fetchAdvanceAmount = async () => {
      try {
        const user = JSON.parse(localStorage.getItem("user"));
        const employeeId = user?.EmployeeID;
  
        if (!employeeId) return;
  
        const response = await axiosInstance.get(`/api/user-advance-amount/${employeeId}`);
        console.log('response',response);
        setAdvanceAmount(response.data.totalAmount || 0);
      } catch (error) {
        console.error("Error fetching advance amount:", error);
      }
    };
  
    fetchAdvanceAmount();
  }, []);
  
  const currentDate = new Date();

  const [selectedMonth, setSelectedMonth] = useState(currentDate.getMonth() + 1);
  const [selectedYear, setSelectedYear] = useState(currentDate.getFullYear());
  useEffect(() => {
    /*const fetchWorkerData = async () => {
      try {
        const response = await axiosInstance.get("api/worker-wages");
        let filteredData = response.data.filter(
          (item) => item.EmployeeID === user?.EmployeeID
        );

        // Normalize dates to prevent timezone mismatches
        if (startDate && endDate) {
          const start = new Date(startDate);
          start.setHours(0, 0, 0, 0); // Set time to midnight
          const end = new Date(endDate);
          end.setHours(23, 59, 59, 999); // Include the full end day

          filteredData = filteredData.filter((item) => {
            const itemDate = new Date(item.Payroll_Entry_Date);
            return itemDate >= start && itemDate <= end;
          });
        }

        // Apply the item filter if a specific item is selected (not "All")
        if (selectedItem && selectedItem !== "All") {
          filteredData = filteredData.filter(
            (item) => item["ITEM NAME"] === selectedItem
          );
        }
        setWorkerData(filteredData);

        // Update total amount based on filtered data
        const total = filteredData.reduce((sum, item) => sum + item.AMOUNT, 0);
        setTotalAmount(total.toFixed(2)); // Keep 2 decimal places

        // Calculate total quantity
        const qtyTotal = filteredData.reduce(
          (sum, item) => sum + Number(item.QTY),
          0
        );
        setTotalQty(qtyTotal);

        const handleResize = () => {
          setIsMobile(window.innerWidth <= 768);
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
      } catch (error) {
        console.error("Error fetching worker wages data:", error);
      }
    };*/

    const fetchMonthlySummary = async () => {
      try {
        if (!user?.EmployeeID) return;

        const response = await axiosInstance.get(
          `/api/user-total-summary-monthly/${user.EmployeeID}?month=${selectedMonth}&year=${selectedYear}`
        );

        setTotalAmount(response.data.totalAmount || 0);
        setTotalQty(response.data.totalQty || 0);
      } catch (error) {
        console.error("Error fetching monthly summary:", error);
      }
    };

    fetchMonthlySummary();
  }, [user?.EmployeeID, startDate, endDate, selectedItem]);

  useEffect(() => {
    const fetchLotWiseData = async () => {
      try {
        if (!user?.EmployeeID) return;

        const response = await axiosInstance.get(
          `/api/user-monthly-lotwise/${user.EmployeeID}`
        );

        setAllLotWiseData(response.data);   // master
        setLotWiseData(response.data);      // initial view
      } catch (error) {
        console.error("Lotwise fetch error:", error);
      }
    };

    fetchLotWiseData();
  }, [user?.EmployeeID]);

  const totalPages = Math.ceil(lotWiseData.length / itemsPerPage);
  const paginatedData = lotWiseData.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const nextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  const prevPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };
  //end

  const getISTTime = () => {
    const now = new Date();
    // Convert the time to IST
    const offset = 5.5 * 60 * 60 * 1000; // IST is UTC + 5:30
    const istTime = new Date(now.getTime() + offset);
    return istTime.toISOString().replace("T", " ").slice(0, 19); // Format as 'YYYY-MM-DD HH:MM:SS'
  };

  /// 3 Dec 24 //  yogesh
  // Fetch user department
  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await axiosInstance.get("/api/AllUsers");
        const users = response.data;

        const userDepartment = users.find(
          (u) => u.EmployeeID === user?.EmployeeID
        )?.Department;
        setDepartment(userDepartment || "Not Assigned");
      } catch (error) {
        console.error("Error fetching users:", error);
      }
    };

    const fetchTemporaryDepartments = async () => {
      try {
        const response = await axiosInstance.get("/api/temporaryDepartments");
        const temporaryData = response.data;

        const tempDept = temporaryData.find(
          (temp) => temp.EmployeeID === user?.EmployeeID
        )?.TemporaryDepartment;
        setTemporaryDepartment(tempDept || "Not Assigned");
      } catch (error) {
        console.error("Error fetching temporary departments:", error);
      }
    };

    fetchUsers();
    fetchTemporaryDepartments();
  }, [user?.EmployeeID]);
  //end
  useEffect(() => {
    const checkSessionExpiration = () => {
      const sessionExpiration = localStorage.getItem("sessionExpiration");
      const currentTime = new Date();

      if (!sessionExpiration || currentTime > new Date(sessionExpiration)) {
        // handleLogout(); // Automatically logout if session expires
        window.location.reload(); // Reload the page after logout
      }
    };

    // Check session expiration immediately
    checkSessionExpiration();

    // Optionally, check periodically (e.g., every 5 seconds)
    const interval = setInterval(checkSessionExpiration, 5000);

    return () => clearInterval(interval); // Cleanup interval on unmount
  }, []);

  // Handle "IN" Button Click
  const handleMarkIn = async () => {
    const loginTime = getISTTime();

    try {
      // Check for active session using /presentEmployees API
      const activeSessionResponse = await axiosInstance.get(
        "/api/presentEmployees"
      );
      const activeEmployees = activeSessionResponse.data;

      // Check if the user is already logged in
      const isActive = activeEmployees.some(
        (employee) => employee.EmployeeID === user?.EmployeeID
      );

      if (isActive) {
        showAlert("You are already marked in.", "danger");
        return; // Stop further processing
      }

      // Proceed with marking IN if no active session exists
      await axiosInstance.post("/api/mark-in", {
        EmployeeID: user?.EmployeeID,
        LoginTime: loginTime,
        Department: department,
      });
      showAlert("Marked In successfully!", "success");
    } catch (err) {
      console.error("Error marking login time:", err);
      alert("Failed to record login time. Please try again.");
    }
  };

  // Handle "OUT" Button Click
  const handleMarkOut = async () => {
    try {
      // Check for active session using /presentEmployees API
      const activeSessionResponse = await axiosInstance.get(
        "/api/presentEmployees"
      );
      const activeEmployees = activeSessionResponse.data;

      // Check if the user has an active session
      const isActive = activeEmployees.some(
        (employee) => employee.EmployeeID === user?.EmployeeID
      );

      if (!isActive) {
        showAlert("No active session found. You are not marked in.", "danger");
        return; // Stop further processing
      }

      if (!window.confirm("Are you sure you want to mark out?")) {
        return;
      }

      // Proceed with marking OUT if an active session exists
      const logoutTime = getISTTime();
      await axiosInstance.post("/api/logout", {
        EmployeeID: user?.EmployeeID,
        logoutTime: logoutTime, // Optional: Can be handled by the backend as well
      });

      showAlert("Marked Out successfully!", "success");

      // Clear local storage and navigate to login page (if needed)
      // localStorage.removeItem("user");
      // localStorage.removeItem("loginTime");
      // navigate("/"); // Redirect to login page (optional)
    } catch (err) {
      console.error("Error marking logout time:", err);
      showAlert("Failed to record logout time. Please try again.", "danger");
    }
  };

  const showAlert = (message, type) => {
    const alertPlaceholder = document.getElementById("alertPlaceholder");
    const alertHTML = `
      <div class="alert alert-${type} alert-dismissible fade show" role="alert">
        <strong>${
          type === "success" ? "Success!" : "Error!"
        }</strong> ${message}
        <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
      </div>`;
    alertPlaceholder.innerHTML = alertHTML;
    setTimeout(() => {
      alertPlaceholder.innerHTML = "";
    }, 3000);
  };

  /*useEffect(() => {
    const fetchUserItems = async () => {
      try {
        const response = await axiosInstance.get("api/user-items");
        // Filter for the logged in user using EmployeeID from AuthContext
        const userItems = response.data.filter(
          (item) => item.EmployeeID === user?.EmployeeID
        );
        // Assuming your API already returns unique rows,
        // map to an array of item names.
        const items = userItems.map((item) => item["ITEM NAME"]);
        setUniqueItems(items);
      } catch (error) {
        console.error("Error fetching user items:", error);
      }
    };

    if (user?.EmployeeID) {
      fetchUserItems();
    }
  }, [user?.EmployeeID]);*/

  useEffect(() => {
    if (!allLotWiseData.length) {
      setUniqueItems([]);
      return;
    }

    const items = [
      ...new Set(allLotWiseData.map((item) => item.ITEM_NAME)),
    ];

    setUniqueItems(items);
  }, [allLotWiseData]);

  useEffect(() => {
    if (selectedItem === "All") {
      setLotWiseData(allLotWiseData);
    } else {
      const filtered = allLotWiseData.filter(
        (item) => item.ITEM_NAME === selectedItem
      );
      setLotWiseData(filtered);
    }
  }, [selectedItem, allLotWiseData]);

  const columns = [
    {
      name: "ITEM NAME",
      selector: (row) => row.ITEM_NAME,
      sortable: true,
    },
    {
      name: "WORKER NAME",
      selector: (row) => row.WORKER_NAME,
      sortable: true,
    },
    {
      name: "QTY",
      selector: (row) => row.QTY,
      sortable: true,
    },
    {
      name: "AMOUNT",
      selector: (row) => row.AMOUNT,
      sortable: true,
    },
    {
      name: "PERIOD",
      selector: (row) =>
        row.Period_Start && row.Period_End
          ? `${new Date(row.Period_Start).toLocaleDateString("en-GB")} - ${new Date(
              row.Period_End
            ).toLocaleDateString("en-GB")}`
          : "N/A",
    },
    {
      name: "Last Refreshed",
      selector: (row) =>
        row.CreatedOn
          ? new Date(row.CreatedOn).toLocaleDateString("en-GB")
          : "N/A",
    },
  ];


  /*const columns = [
    {
      name: "LOT NO",
      selector: (row) => row.LOT_NO,
      sortable: true,
    },
    {
      name: "ITEM NAME",
      selector: (row) => row.ITEM_NAME,
      sortable: true,
    },
    {
      name: "PROCESS",
      selector: (row) => row.PROCESS_NAME,
    },
    {
      name: "QTY",
      selector: (row) => row.QTY,
    },
    {
      name: "AMOUNT",
      selector: (row) => row.AMOUNT,
    },
    {
      name: "DATE",
      selector: (row) =>
        row.CREATED_ON
          ? new Date(row.CREATED_ON).toLocaleDateString("en-GB")
          : "N/A",
    },
  ];*/

  return (
    <div className=" ">
      <div id="alertPlaceholder"></div>
      <nav
        className="navbar navbar-expand-lg bg-body-white"
        style={{ boxShadow: "0 1px 5px rgba(0, 0, 0, 0.2) " }}
      >
        <div className="container-fluid">
          <a className="navbar-brand">
            {" "}
            <img
              src={Logo}
              className="img-fluid rounded-top"
              alt="Logo"
              style={{ height: "40px", marginLeft: "10px" }}
            />
          </a>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav me-auto mb-2 mb-lg-0">
              <li className="nav-item" style={{ marginLeft: "10px" }}>
                <a
                  className="nav-link active"
                  aria-current="page"
                  href="/User-Tickets"
                  onMouseEnter={() => setHover(true)}
                  onMouseLeave={() => setHover(false)}
                  style={{
                    color: hover ? "#ff0000" : "inherit", // Changes to #ff0000 on hover
                  }}
                >
                  TICKET
                </a>
              </li>
            </ul>
          </div>
        </div>
        {/* Navbar Links and Profile Dropdown */}
        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav me-auto mb-2 mb-lg-0"></ul>
          <span style={{ marginLeft: "-21rem" }}>Welcome,{user?.Name}! </span>
          {/* Profile Dropdown */}
          <div className="dropdown">
            <a
              className="d-flex align-items-center text-decoration-none dropdown-toggle ml-5 "
              // href="#"
              role="button"
              id="dropdownMenuLink"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              style={{
                marginRight: "20px",
                justifyContent: "end",
                marginLeft: "10px",
                ...(isMobile && { marginTop: "-41px" }),
              }}
            >
              <img
                src={User}
                alt="Profile"
                className="rounded-circle"
                style={{
                  width: "40px",
                  height: "40px",
                  objectFit: "cover",
                }}
              />
            </a>
            <ul
              className="dropdown-menu dropdown-menu-end"
              aria-labelledby="dropdownMenuLink"
            >
              {/* <li>
                  <a className="dropdown-item" href="#">
                    My Profile
                  </a>
                </li> */}
              <li>
                <a
                  className="dropdown-item text-danger"
                  // href="#"
                  // onClick={handleLogout}
                  onClick={logout}
                >
                  Logout
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
      {/* <main>
        <div className="container">
          <p>Employee ID: {user?.EmployeeID}</p>
          <p>Department: {department}</p>
          <p>Assigned Department: {temporaryDepartment}</p>
        </div>
      </main> */}
      <div
        className="dashboard-container"
        style={{ background: "#f7f9fc", height: "-webkit-fill-available" }}
      >
        <main style={{ padding: "20px" }}>
          <div
            className="dashboard-content"
            style={{ maxWidth: "800px", margin: "0 auto" }}
          >
            <div
              className="card"
              style={{
                background: "white",
                // background: "linear-gradient(90deg,orange, orange,orange, white,white, white,green, green, green)",
                padding: "20px",
                borderRadius: "8px",
                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                marginBottom: "20px",
              }}
            >
              <span
                style={{
                  marginBottom: "40px",
                  color: "#ff0000",
                  textAlign: "center",
                }}
              >
                Please Don't Forget To Logout After Complete Your Work
              </span>
              <p
                style={{
                  fontSize: "18px",
                  color: "black",
                  marginBottom: "8px",
                }}
              >
                <strong>Employee ID:</strong> {user?.EmployeeID}
              </p>
              <p
                style={{
                  fontSize: "18px",
                  color: "black",
                  marginBottom: "8px",
                }}
              >
                <strong>Department:</strong> {department || "Not Assigned"}
              </p>
              <p
                style={{
                  fontSize: "18px",
                  color: "black",
                  marginBottom: "8px",
                }}
              >
                <strong>Assigned Department:</strong>{" "}
                {temporaryDepartment || "Not Assigned"}
              </p>
              <p
                style={{
                  fontSize: "18px",
                  color: "black",
                  marginBottom: "8px",
                }}
              >
                <strong>Total Amount:</strong> ₹{totalAmount}
              </p>
              <p
                style={{
                  fontSize: "18px",
                  color: "black",
                  marginBottom: "8px",
                }}
              >
                <strong>Total Quantity:</strong> {totalQty}
              </p>
              <p
                style={{
                  fontSize: "18px",
                  color: "black",
                  marginBottom: "8px",
                }}
              >
                <strong>Advance Amount:</strong> ₹{advanceAmount}
              </p>

              {/* Buttons for IN and OUT */}
              <div
                style={{ display: "flex", justifyContent: "end", gap: "20px" }}
              >
                <button className="btn btn-success" onClick={handleMarkIn}>
                  IN
                </button>
                <button className="btn btn-danger" onClick={handleMarkOut}>
                  OUT
                </button>
              </div>
            </div>
          </div>

          <div className="container mt-4 d-flex flex-wrap responsive-date-picker">
            
            {/* Separate Item Filter Dropdown */}
            <div className="dropdown mb-2 me-2">
              <label className="form-label">Item Name: </label>&nbsp;
              <select
                className="form-control "
                value={selectedItem}
                onChange={(e) => setSelectedItem(e.target.value)}
              >
                <option value="All">All</option>
                {uniqueItems.map((item, index) => (
                  <option key={index} value={item}>
                    {item}
                  </option>
                ))}
              </select>
            </div>
            {/* Reset Button */}
            <div className="mb-2" style={{ marginTop: "auto" }}>
              <button
                className="btn btn-secondary mt-4"
                onClick={() => {
                  setSelectedItem("All");
                }}
              >
                Reset
              </button>
            </div>
          </div>
          <div
            className="container mt-4"
            style={{
              boxShadow: "0 1px 5px rgba(0, 0, 0, 0.51)",
              borderRadius: "5px",
              padding: "6px",
            }}
          >
            {!isMobile ? (
              <DataTable
                columns={columns}
                data={lotWiseData}
                pagination
                highlightOnHover
                noDataComponent="There are no records to display"
              />
            ) : (
              <>
                <div className="row">
                  {paginatedData.length > 0 ? (
                    paginatedData.map((item, index) => (
                      <div className="col-12 mb-3 mt-2" key={index}>
                        <div className="card p-3 shadow-sm">
                          <h5 className="card-title">{item.ITEM_NAME}</h5>

                          <p className="card-text">
                            <strong>Worker:</strong> {item.WORKER_NAME}
                          </p>

                          <p className="card-text">
                            <strong>Quantity:</strong> {item.QTY}
                          </p>

                          <p className="card-text">
                            <strong>Amount:</strong> ₹{item.AMOUNT}
                          </p>

                          <p className="card-text">
                            <strong>Period:</strong>{" "}
                            {new Date(item.Period_Start).toLocaleDateString("en-GB")} -{" "}
                            {new Date(item.Period_End).toLocaleDateString("en-GB")}
                          </p>

                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="col-12 text-center mt-3">
                      <p>No data found.</p>
                    </div>
                  )}
                </div>

                {totalPages > 1 && (
                  <div className="d-flex justify-content-between mt-3">
                    <button
                      className="btn btn-primary mb-3"
                      onClick={prevPage}
                      disabled={currentPage === 1}
                    >
                      Previous
                    </button>
                    <span>
                      Page {currentPage} of {totalPages}
                    </span>
                    <button
                      className="btn btn-primary mb-3"
                      onClick={nextPage}
                      disabled={currentPage === totalPages}
                    >
                      Next
                    </button>
                  </div>
                )}
              </>
            )}
          </div>
        </main>
      </div>
    </div>
  );
}

export default UserDashboard;
